import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import DateRangePicker from "../Reusable/DateRangeField";
import MultipleSelectField from "../Reusable/MultipleSelectField";

export default function Filter(props: any) {
  const { register, errors, setValue, getValues, clearErrors, watch } = props;
  return (
    <div
      className={tw`p-2 rounded-md space-y-2 bg-[#fefefe]`}
      style={{
        boxShadow: "0px 1px 6px 0px #00000040",
      }}
    >
      <div className={tw`grid grid-cols-3 gap-6`}>
        <MultipleSelectField
          label={"Account"}
          queryKey={"inventory"}
          register={register("account__in")}
          watch={watch}
          setValue={setValue}
          url={APIS.PRODUCT}
          errors={errors.account__in}
          value={[]}
          props={{}}
        />
        {/* <ComboboxInput
          url={APIS.USER}
          queryKey={"party"}
          register={register("user")}
          errors={errors?.user}
          name={"user"}
          label={"Party"}
          setValue={setValue}
          getValues={getValues}
          placeholder={"Search... "}
          clearErrors={clearErrors}
        /> */}
        <DateRangePicker
          label={"Select Date Range"}
          setValue={setValue}
          name={"created__range"}
          getValues={getValues}
        />
      </div>
    </div>
  );
}
